<template>
  <div class="CartCalculator">
    <div class="cart-calculator">
    
      <template v-if="!loading">
   
      <ul class="list-group mb-3">
     

        <li class="list-group-item d-flex justify-content-between">
          <span>Total (PEN)</span>
          <strong>{{totalValue | currency}}</strong>
        </li>
         <li class="list-group-item d-flex justify-content-between">
          <small><strong><input type="checkbox" id="checkbox" v-model="checked"> He leido y estoy de acuerdo con las <router-link to="/guia/7" target= '_blank'>Terminos y Condiciones</router-link> de IFF.</strong></small>
        </li>
    
      <template  v-if="cartProducts.length > 0">
        <template  v-if="general_allowed_sale == true">
          <template v-if="general_allowed_tpv == true">
            <template v-if="checked === true">
               <template v-if="userdata === true">
                 <router-link :to="'/datos-compra'" class="btn btn-primary mt-2 text-white" :disabled="checked === false">Siguiente</router-link>
               </template>
               <template v-else>
                 <a data-toggle="modal" data-target="#myModal2" class="btn btn-primary mt-2 text-white" :disabled="checked === false" href>Siguiente</a>
               </template>
            </template>
          </template>
          <template v-else>
            <button class="btn btn-primary mt-2 text-white" :disabled="checked === false"  @click="islogged()">Solicitar pedido</button>
          
             <li class="list-group-item d-flex justify-content-between">
              <small><strong>IMPORTANTE: El pedido de los productos seleccionados se realizará utilizando sus datos de registro en el sitio como identificación, si desea modificar sus datos de registro puede hacerlo <router-link to="/perfil">aquí</router-link>. Puede revisar el estado de sus pedidos realizados y el detalle de los mismos <router-link to="/pedidos">aquí</router-link>.</strong></small>
            </li>
          </template>
        </template>
        <template v-else>
          <small style="color:#dc3545;">Uno o varios de los productos seleccioandos no se encuentran habilitados para el pedido o venta online. Agrege solamente productos habilitados.</small>
        </template>
      </template>
        <!--<router-link to="/payment" class="btn btn-danger mt-2 text-white">Checkout</router-link>-->

      </ul>
       </template>
       <template v-else-if="loading==true"> 
         <li class="list-group-item">
          <i class="fa fa-refresh fa-spin fa-3x fa-fw fa-mrbig"></i>
           <template v-if="general_allowed_tpv == true">
             <p>Estamos procesando su compra. Por favor, espere.</p> 
          </template>
          <template v-else>
             <p>Estamos procesando su pedido. Por favor, espere.</p> 
          </template>
        </li>
      
       </template>
       <div :class="[(mensaje === '') ? 'd-none' : 'alert alert-success']" role="alert"><button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button><strong>{{ mensaje }}<router-link to="/pedidos">aquí</router-link>.</strong></div>
       <div :class="[(mensaje_error === '') ? 'd-none' : 'alert alert-danger']" role="alert"><button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button><strong><span v-html="mensaje_error"></span></strong></div>
        
    </div>
  </div>
</template>

<script>
import toastr from 'toastr'
import { mapState, mapActions, mapMutations } from "vuex";
import { config_settings } from "../../../../config.js";
import axios from "axios";
import { successToaster, errorToaster } from "../../../../components/shared/service/ErrorHandler.js";
import _ from "lodash";

Culqi.publicKey = 'pk_test_cZJm1j7hvWp5lmPt';

//HTTP ERROR STATUS
  const NOT_FOUND = 404;
  const BAD_REQUEST = 400;
  const UNAUTHORIZED = 401;
  const CONFLICT = 409;
  const INTERNAL_SERVER_ERROR = 500;
  const BAD_GATEWAY = 502;

  
  axios.interceptors.response.use(function (response) { return response; }, 
  function (error) {
    console.log(error)
    if(error.message === 'Network Error'){
      toastr.error("No se puede conectar con el servidor. Verifique su conexión a internet",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
    }
    else if(error.response.status === UNAUTHORIZED){
      if(error.response.data.message === "Access is denied"){
         toastr.error("Usted no tiene los provilegios para acceder a esta sección",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
      }
      else {
        return Promise.reject(error);
      }
    }
    else {
      return Promise.reject(error);
    }
});

export default {
  name: "cartCalculator",
  data() {
    return {
      checked: true,
      userdata: false,
      loading: false,
      tokenID: "",
      totalValue: 0.0,
      products_data: [],
      general_allowed_sale: true,
      general_allowed_tpv: true,
      mensaje: "",
      mensaje_error: "",
       showLoader: false,
      client_email: "",
      client_username: "",
      client_name: "",
      client_lastname: "",
      client_dni: "",
      cliente_phone: "",
      cboDepartamento: "",
      cboProvincia: "",
      cboDistrito: "",
      client_address: "",
      cboDepartamento: "",
      depas_array: [],
      province_array: [],
      distrito_array: [],
      isdisabled: true,
      isdisabled_distrito: true,
      isdisabled_direccion: true,
      token: localStorage.getItem('access_token'),
      refresh_token: localStorage.getItem('refresh_token')
     
    }
  },
  computed: mapState(["cartProducts"]),
  methods: {
    analizeCart() {
      let actual_total = 0;
      this.general_allowed_sale = true;
      this.cartProducts.forEach((product, index) => {
        if(product.allowed_sale==false){
          this.general_allowed_sale = false
        }
        if(product.allowed_tpv==false){
          this.general_allowed_tpv = false
        }
        var subtotal = ((product.price_product/1.18) * (product.qty * 1.18)) * 100;
        subtotal = (Math.round(subtotal))/100.0
        actual_total = actual_total + subtotal;
      });
      this.totalValue = Math.round(actual_total*100)/100;
    },
    /*
    analizeCart() {
        let actual_total = 0.00;
        this.general_allowed_sale = true;
        this.cartProducts.forEach((product, index) => {
            if(product.allowed_sale == false){
                this.general_allowed_sale = false;
            }
            if(product.allowed_tpv == false){
                this.general_allowed_tpv = false;
            }
            console.log("precio del delivery "+this.gen_delivery_cost);
            actual_total += product.original_price * product.qty; // Utilizar el precio original del producto
        });

        // Aplicando la modificación sugerida por tu jefe
        this.gen_delivery_cost = this.delivery_detail.delivery_cost ? this.delivery_detail.delivery_cost : 0;

        this.totalValue = actual_total + this.gen_delivery_cost;
    },
    */

    refreshToken(){
          var refresh_token = localStorage.getItem('refresh_token');
          var refresh_credentials = new FormData();
          refresh_credentials.append('grant_type', 'refresh_token');
          refresh_credentials.append('refresh_token',  refresh_token);
          refresh_credentials.append('id_store',  config_settings.STORE);

          const refreshingCall = axios({
            method: 'post',
            url: config_settings.AUTH_SERVER_URL+'/oauth/token',
            data: refresh_credentials,
            withCredentials: true,
            auth: {
                username: 'USER_CLIENT_APP',
                password: 'password'
            }})
            .then(response => {
              localStorage.setItem('access_token', response.data.access_token);
              localStorage.setItem('refresh_token', response.data.refresh_token);
              return Promise.resolve(true);
            });
            return refreshingCall;
    },

    get_puser_data()
    { 
      this.userdata = false;
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL+'/GET/profile',
        headers: {
          Authorization: "Bearer " + localStorage.getItem('access_token')
        }
      })
      .then(response => {
        console.log("responde todo");
        this.userdata = true;
        this.client_email = response.data.email_client
        this.client_username = response.data.nick_client
        this.client_name = response.data.name_client
        this.client_lastname = response.data.surname_client
        this.client_dni = response.data.dni_client
        this.cliente_phone = response.data.phone_client
        this.client_address = response.data.address_client
        
        var cboDistrito =  response.data.id_district.id_district;
        if(cboDistrito!=0){
          this.cboDistrito =  response.data.id_district.id_district;
        }
        else {
          this.cboDistrito = "";
        }
        console.log("responde todo"+this.userdata);
      })
      .catch(error => {
        if(error.response.status === UNAUTHORIZED){
           this.refreshToken().then(_ => {
           this.get_puser_data();
           })
           .catch(_ => {
             this.userdata = false;
           });
         }
         else {
           this.userdata = false;
           toastr.error(error.response.data.details,
                       error.response.data.message,
                       {"iconClass": 'customer-danger'});
         }  
      })
    },

    islogged() {
      if(this.userdata==true){

        if(this.client_dni == null || this.cliente_phone == null || this.cboDistrito =="" || this.client_address == ""){
          
          this.mensaje = "";
          this.mensaje_error = "Debe ingresar sus datos completos para poder realizar un pedido. Actualize todos sus datos <a href='/perfil'>aquí</a> e inténtelo nuevamente.";
       
        }
        else {
          this.generate_order();
        }

      }
      else {
        toastr.error("Debe iniciar sesión antes de continuar",
                       "Aviso",
                       {"iconClass": 'customer-danger'});
           this.mensaje_error = "Debe iniciar sesión antes de continuar";
           this.mensaje = "";
                       this.$router.push({path: '../../login/'})
      } 
       
    },

    pagar(){
      if(this.userdata==true){
        if(this.client_dni == null || this.cliente_phone == null || this.cboDistrito =="" || this.client_address == ""){
          
          this.mensaje = "";
          this.mensaje_error = "Debe ingresar sus datos completos para poder realizar una compra. Actualize todos sus datos <a href='/perfil'>aquí</a> e inténtelo nuevamente.";
       
        }
        else {
          this.openCulqiForm();
        }
        
      }
      else {
        toastr.error("Debe iniciar sesión antes de continuar",
                       "Error",
                       {"iconClass": 'customer-danger'});
           this.mensaje_error = "Debe iniciar sesión antes de continuar";
           this.mensaje = "";
                       this.$router.push({path: '../../login/'})
      }
    },

    openCulqiForm(){
      //verificar si el cliente tiene todos los datos completos antes de habilitar la pasarela de pagos
     
      //this.get_puser_data();

      
          Culqi.settings({
          title: 'Proceso de Pago',
          currency: 'PEN',
          description: 'Ingrese los datos de su tarjeta de crédito o débito para continuar',
          amount: this.totalValue * 100
          });

        Culqi.open();
        
      

    },
    
    generate_charge(tokenID, email) {

      this.loading = true;

      this.cartProducts.forEach((product, index) => {
        this.products_data[index] = { "code_product" : product.code_product,
                                      "quantity" : product.qty };
      });

      var json_data = {
        "tokenID" : tokenID,
        "email" : email,
        "sales_detail" : this.products_data
      }
      
      axios({
        method: 'post',
        url: config_settings.RESOURCE_SERVER_URL + '/POST/cdp',
        data: json_data,
        headers: {
          Authorization: "Bearer " + localStorage.getItem('access_token')
        }
      }).then(response => {
        console.log(response.data);
        this.loading = false;
        this.removeAllProductCart();
        this.mensaje = "Su compra fue efectuada correctamente, se le enviarán los detalles y el cargo a su correo electrónico. Tambien puede revisar el detalle de sus compras y pedidos "
        this.mensaje_error = ""
      }).catch(error => {
        if(error.response.status === UNAUTHORIZED){
           this.refreshToken().then(_ => {
           this.generate_charge(tokenID, email);
           })
           .catch(_ => {
           toastr.error("Debe iniciar sesión antes de continuar",
                       "Error",
                       {"iconClass": 'customer-danger'});
           this.mensaje_error = "Debe iniciar sesión antes de continuar";
           this.mensaje = "";
                       this.$router.push({path: '../../login/'})
           });
         }
         else if(error.response.status === BAD_GATEWAY){
           console.log(error.response.data.details);
            this.loading = false;
            this.removeAllProductCart();
            this.mensaje = "Su compra fue efectuada correctamente, sin embargo, es posible que haya existido un error al enviarle los detalles de la transacción al correo electrónico. Puede revisar el detalle de sus compras y pedidos "
            this.mensaje_error = ""    
         }
         else {
            console.log(error.response.data);
            this.mensaje = ""
            this.mensaje_error = error.response.data.details
            this.loading = false;
         }
        
      });
    },

    generate_order() {
      this.loading = true;
      this.cartProducts.forEach((product, index) => {
        this.products_data[index] = { "code_product" : product.code_product,
                                      "quantity" : product.qty };
      });

      var json_data = {
        "sales_detail" : this.products_data
      }
      
      axios({
        method: 'post',
        url: config_settings.RESOURCE_SERVER_URL + '/POST/order_tracking',
        data: json_data,
        headers: {
          Authorization: "Bearer " + localStorage.getItem('access_token')
        }
      }).then(response => {
        console.log(response.data);
        this.loading = false;
        this.removeAllProductCart();
        this.mensaje = "Su pedido fue solicitado correctamente, se le enviarán los detalles a su correo electrónico. Tambien puede revisar el detalle de sus compras y pedidos "
        this.mensaje_error = ""    
      }).catch(error => {
        if(error.response.status === UNAUTHORIZED){
           this.refreshToken().then(_ => {
           this.generate_order();
           })
           .catch(_ => {
           this.mensaje_error = "Debe iniciar sesión antes de continuar";
           this.mensaje = "";
                       this.$router.push({path: '../../login/'})
           });
         }
         else if(error.response.status === BAD_GATEWAY){
           console.log(error.response.data.details);
            this.loading = false;
            this.removeAllProductCart();
            this.mensaje = "Su pedido fue solicitado correctamente, sin embargo, es posible que haya existido un error al enviarle los detalles al correo electrónico. Puede revisar el detalle de sus compras y pedidos "
            this.mensaje_error = ""    
         }
         else if(error.response.status === BAD_REQUEST){
           console.log(error.response.data.details);
            this.loading = false;
           // this.removeAllProductCart();
           if(error.response.data.details==="One or more of the selected products have no stock available"){
             this.mensaje_error = "Lo sentimos. Uno o más productos que usted ha solicitado ya no tienen stock disponible. "
           }
           else if(error.response.data.details==="One or more of the selected products are not available for online ordering"){
             this.mensaje_error = "Lo sentimos. Uno o más productos que usted ha solicitado no se encuentran disponibles para pedido online. "
           }
            this.mensaje = ""    
         }
         else {
           console.log(error.response.data);
            this.mensaje = ""
            this.mensaje_error = "Lo sentimos, se ha sucitado un error. Inténtelo nuevamente.";
            this.loading = false;
         }
        
      });
    },


    ocultar(){
       this.mensaje=""
       this.mensaje_error=""
    },
    ...mapMutations(["SET_CART_PRODUCTS"]),
  
    removeAllProductCart() {
        var products = [];
        this.SET_CART_PRODUCTS(products);
        localStorage.setItem("iki-cart", JSON.stringify(products));
        this.analizeCart();
    }
  },
  
  created() {
    this.analizeCart();
    this.get_puser_data();
  },
  

  mounted() {
    var that = this;
    window.culqi = function() {
      if (Culqi.token) { 
        let tokenID = Culqi.token.id;
        let email = Culqi.token.email;
        that.generate_charge(tokenID, email);
      }
      else {
        console.log(Culqi.error);
      }
    }
  }
}
</script>

<style lang="scss" src="./CartCalculator.scss"></style>
